import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
const OwlCarouselSliderHomeFacilityCampus = (props) => {	
	 const [activeId, setActiveId] = useState(1);
	 const [activeIdTab, setActiveIdTab] = useState(1);
	 const options = {
	 	 loop:true,
		margin:0 -1,
		nav:true,
		dots: false,
		navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
		responsive:{
			0:{
				items:2
			},
			480:{
				items:3
			},			
			
			767:{
				items:4
			},
			991:{
				item:4
			},
			1000:{
				items:5
			}
		}
    };
	
    return(
	<>   
	<OwlCarousel className="our-pricing-carousel owl-btn-vertical-center owl-btn-hover nav nav-tabs" {...options}>	 
	{props.data.map((item, index) => (	
		<div className={`item ${activeId ===item.id ? ' active-arrow' : ''}`} onClick={() => setActiveId(item.id)}  key={item.id}>
			<Link data-bs-toggle="tab" className="tab-block">
				<div className="our-pricing-tab  radius-sm bdr-1 bdr-gray">
					<div className="wt-icon-box-wraper center  p-lr10">
						<div className="icon-lg m-b5">
							<span className="icon-cell  text-black"><i className={item.icon}></i></span>
						</div>
						<div className="icon-content">
							<span className="wt-tilte text-uppercase p-b10 inline-block font-weight-600">{item.title}</span>
						</div>
					</div>
				</div>
			</Link>
		</div>
	 ))}                     		
	</OwlCarousel>
	
	<div className="tab-content m-b30">
		{props.data.map((item, index) => (		
			<div id={"#pricing-item" + item.id}  className={`pricing-tab-content-block tab-pane ${activeId ===item.id ? ' active-arrow' : ''}`} key={item.id}>
				<div className="section-content p-t50">
						{/* <!-- TABS DEFAULT NAV LEFT --> */}
						<div className="wt-tabs vertical bg-tabs">
							<ul className="nav nav-tabs">
								{item.tab.map((itemtab, index) => (
									<li className="nav-item" key={itemtab.id}>
										<Link className={`nav-link ${activeIdTab ===itemtab.id ? ' active' : ''}`} onClick={() => setActiveIdTab(itemtab.id)} data-bs-toggle="tab">{itemtab.title}</Link>
									</li>								
								 ))}
							</ul>
							<div className="tab-content p-l50">
							{item.tab.map((itemtab, index) => (
								<div id="pricing-tab1-1" className={`tab-pane ${activeIdTab ===itemtab.id ? ' active' : ''}`} key={itemtab.id}>
									<div className="pricing-tab-inner">
										<div className="row">
											<div className="col-lg-6 col-md-12">
												<div className="wt-media">
													<img src={itemtab.image} alt="" />
												</div>
											</div>
											<div className="col-lg-6 col-md-12">
												<div className="wt-tilte">
													<h3 className="font-26 font-weight-400">{itemtab.title} </h3>
													
													<p>{itemtab.description}</p>
													<Link to={itemtab.link} className="site-button skew-icon-btn radius-sm">
													  <span className="font-weight-700 inline-block text-uppercase p-lr15">More</span> 
													</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
								 ))}					
								
							</div>
						</div>
					</div>
			</div>
		))}	
	</div>		
    </>
    )
}
export default OwlCarouselSliderHomeFacilityCampus;